import { render, staticRenderFns } from "./PartenairesView.vue?vue&type=template&id=633e2a2b&scoped=true"
import script from "./PartenairesView.vue?vue&type=script&lang=js"
export * from "./PartenairesView.vue?vue&type=script&lang=js"
import style0 from "./PartenairesView.vue?vue&type=style&index=0&id=633e2a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e2a2b",
  null
  
)

export default component.exports